import { createSlice } from "@reduxjs/toolkit";

const locSlice = createSlice({
  name: "location",
  initialState: {
    latitude: 0,
    longitude: 0,
    radius: "",
    address: "",
    backPayment: "",
    deliveryPage: "",
    bidPageId: "",
  },
  reducers: {
    getLatitude: (state, action) => {
      state.latitude = action.payload;
    },
    getLongitude: (state, action) => {
      state.longitude = action.payload;
    },
    getRadius: (state, action) => {
      state.radius = action.payload;
    },
    getbackPayment: (state, action) => {
      state.backPayment = action.payload;
    },
    getDeliveryPage: (state, action) => {
      state.deliveryPage = action.payload;
    },
    getBidPageId: (state, action) => {
      state.bidPageId = action.payload;
    },
  },
});

export const {
  getLatitude,
  getLongitude,
  getRadius,
  getbackPayment,
  getDeliveryPage,
  getBidPageId,
} = locSlice.actions;

export default locSlice.reducer;
